import { render } from "./GameInfo.vue?vue&type=template&id=77b971b4"
import script from "./GameInfo.vue?vue&type=script&lang=js"
export * from "./GameInfo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__